<template>
    <div 
    class="flex-grid"
    :class="[lastColClass, colClass, borderClass]">
    <slot><div class="bg-light-gray-700 h-52 w-full"></div></slot>
  </div>

</template>

<script>
import { computed } from '@vue/runtime-core';

export default {
	props: {
		isLastColCenter: {
			type: Boolean,
			default: true,
			required: false
		},
    numCols: {
			type: Number,
			required: false,
			default: 3
		},
    showBorder: {
      type: Boolean,
      default: false,
      required: false
    },
    colWidth: {
      type: String,
      required: false,
      default: 'normal',
    }
},

	setup(props) {

		const lastColClass = computed(() => ({
			'justify-center': props.isLastColCenter
		}));

		const colClass = computed(() => ({
      'flex-grid--normal': props.colWidth === 'normal',
      'flex-grid--wide': props.colWidth === 'wide',
      'flex-grid--five': props.numCols === 5,
			'flex-grid--four': props.numCols === 4,
			'flex-grid--three': props.numCols === 3,
		}));

    const borderClass = computed(() => ({
      'flex-grid--border': props.showBorder,
    }))
    return {
      colClass,
      borderClass,
			lastColClass,
		}
	},
}
</script>

<style>

</style>